import { hdMovies } from '@/mocks/movies';
import SectionHeading from './SectionHeading';

export default function HdZone() {
  return (
    <section id="hd" className="w-full bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <SectionHeading
            eyebrow="高清专区 · 极致画质"
            title="4K HDR 与蓝光修复影片"
            desc="这里只收录高画质版本，包括 4K HDR、蓝光原盘与经典修复片。适合大屏设备与稳定网络环境，画面细节更完整。"
          />
          <div className="flex flex-wrap gap-2 shrink-0">
            <span className="px-3 py-1.5 rounded-full bg-accent-100 text-accent-900 text-xs">4K HDR</span>
            <span className="px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-900 text-xs">蓝光原盘</span>
            <span className="px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs">修复版本</span>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {hdMovies.map((m) => (
            <article
              key={m.id}
              className="group rounded-lg overflow-hidden bg-background-100 border border-background-200/70 hover:border-accent-400 transition-colors"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={m.poster}
                  alt={`${m.title} 高清影片封面，${m.genres.join('、')}`}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-accent-500 text-accent-950 text-xs font-medium">
                  {m.quality}
                </span>
                <span className="absolute top-3 right-3 inline-flex items-center gap-1 px-2 py-1 rounded-md bg-foreground-950/70 text-accent-300 text-xs">
                  <i className="ri-star-fill"></i>
                  {m.rating}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading font-bold text-lg text-foreground-950">{m.title}</h3>
                <p className="mt-1 text-xs text-foreground-500">
                  {m.subtitle} · {m.year} · {m.region}
                </p>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{m.synopsis}</p>
                <div className="mt-4 flex items-center justify-between text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-timer-line"></i>
                    {m.duration}
                  </span>
                  <span className="inline-flex items-center gap-1 text-secondary-700">
                    <i className="ri-hd-line"></i>
                    {m.genres.join(' / ')}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}